import { Divider as ChakraDivider, DividerProps as ChakraDividerProps } from '@chakra-ui/react';

export interface DividerProps extends ChakraDividerProps {
  orientation?: 'horizontal' | 'vertical';
  size?: '1' | '2';
  variant?: 'dashed' | 'dotted' | 'solid';
}

/**
 * Dividers are used to visually separate content in a list or group.
 */
const Divider = (props: DividerProps) => {
  const { orientation = 'horizontal', size = '1', variant = 'solid', ...rest } = props;
  const properties: ChakraDividerProps = {
    orientation,
    size,
    variant,
    ...rest,
  };
  if (orientation === 'horizontal') {
    properties.borderBottomWidth = `${size}px`;
  } else {
    properties.borderLeftWidth = `${size}px`;
  }
  return <ChakraDivider as="hr" {...properties} />;
};

export default Divider;
